import { useMediaQuery } from "react-responsive";
import { MOBILE_VIEW } from "../../../../variables";
import { useElementSize } from "./remotion-timeline/hooks/use-element-size";
import { PlayerRef } from "@remotion/player";
import { useEffect, useRef } from "react";
import { useAppSelector } from "../../../../redux/hooks";

import MobileView from "./mobile-view";
import DesktopView from "./desktop-view";

import { useSettings } from "./context";
import EditorLoader from "./loader";

const MainView = () => {
  const { loadEditor } = useSettings();
  const isMobile = useMediaQuery({ query: `(max-width: ${MOBILE_VIEW}px)` });

  const playerRef = useRef<PlayerRef>(null);
  const timelineContainerRef = useRef<HTMLDivElement>(null);
  const timelineContainerSize = useElementSize(timelineContainerRef);
  const timelineContainerWidth = timelineContainerSize?.width;

  const video = useAppSelector((state) => state.transcript.data);

  useEffect(() => {
    if (video?.id && video?.videoUrl && video?.duration) {
      loadEditor();
    }
  }, [loadEditor, video?.id, video?.videoUrl, video?.duration]);

  if (!video?.id) return <EditorLoader />;

  return isMobile ? (
    <MobileView
      playerRef={playerRef}
      timelineContainerRef={timelineContainerRef}
      timelineContainerWidth={timelineContainerWidth}
    />
  ) : (
    <DesktopView
      playerRef={playerRef}
      timelineContainerRef={timelineContainerRef}
      timelineContainerWidth={timelineContainerWidth}
    />
  );
};

export default MainView;
